import { z } from 'zod';
import {
    type BaseNodeCfg,
    baseNodeCfgSchema,
} from './base-node';
import {
    SchemaHookKind,
    parseWithHookCfg,
    schemaWithHook,
} from '../../../../../../src/schemaWithHook';
import type { AppletDesignConfig } from '../../../applet-design-config.zod';

export const baseConnectionCfgSchema = baseNodeCfgSchema.extend({
    controlValues: z.object({
        connectionId: z.string(),
    }),
});

export interface BaseConnectionCfgSchema extends z.infer<typeof baseConnectionCfgSchema> {}

/**
 * creates a schema that can be captured by `getConnectionNodes`
 */
export function connectionNodeConfigSchema<SCHEMA extends z.ZodType<BaseNodeCfg>> (mySchema: SCHEMA): SCHEMA {
    return schemaWithHook({
        schema: mySchema,
        hook: SchemaHookKind.ConnectionNode,
    });
}

export function getConnectionNodes (cfg: AppletDesignConfig, schema: z.ZodType) {
    const ret: {
        nodeId: string;
        connectionId: string;
    }[] = [];
    parseWithHookCfg({
        schema,
        hookCfg: {
            [SchemaHookKind.ConnectionNode]: node => {
                const connectionControlValues = node.controlValues;
                if (connectionControlValues && 'connectionId' in connectionControlValues && typeof connectionControlValues.connectionId === 'string') {
                    ret.push({
                        nodeId: node.id,
                        connectionId: connectionControlValues.connectionId,
                    });
                }
                return node;
            },
        },
    }, cfg);
    return ret;
}
